module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "FlexibleImage"
  }, [_c('image-component', _vm._b({
    staticClass: "FlexibleImage-image"
  }, 'image-component', _vm.image, false))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13b8a921"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FlexibleImage.vue
// module id = 741
// module chunks = 1474